import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { OrderBuilderState } from '@ordersnproducts/modules/order-builder/reducers';
import { FormGroup } from '@angular/forms';
import { Observable } from 'rxjs';
import { SelectOptionI } from '@ordersnproducts/modules/shared/modules/configurable-form/components/form-select/models/select-option-i';
import { filter, map, switchMap, tap } from 'rxjs/operators';
import { _safe } from '@ordersnproducts/modules/shared/utils/safe-get.method';
import { getPaymentTermByJobsite } from '@ordersnproducts/modules/order-builder/modules/rms-specification/selectors/payment-terms-by-jobsite.selector';
import { PaymentTermService } from '@cemex-core/cmx-api';
import { SpecFieldNames } from '@ordersnproducts/modules/order-builder/modules/specification/constants/specification-field-names.enum';
import { SelectOptionLoaderI } from '@ordersnproducts/modules/shared/modules/configurable-form/components/form-select/models/select-option-loader-i';

/**
 * A loader service which loads a payment terms by a jobsite.
 * Currently applicable for Colombia RMX, since 95% of Colombia customers
 * do not have contracts assigned.
 * */
@Injectable()
export class PaymentTermsByJobsiteLoaderService implements SelectOptionLoaderI {
  constructor(
    private store: Store<OrderBuilderState>,
    private paymentTermService: PaymentTermService,
  ) {}
  /**
   * Method to load options for payment terms
   * @param formGroup Form group
   * @returns {Observable<SelectOptionI[]>} Observable of options of payment terms
   */
  loadOptions(formGroup: FormGroup): Observable<SelectOptionI[]> {
    return this.store.select(getPaymentTermByJobsite).pipe(
      filter((paymentTerm) => Boolean(paymentTerm)),
      switchMap(({ paymentTermId }) => this.paymentTermService.getJobsitePaymentTermsByIdV2(paymentTermId)),
      // patch value of the form
      tap((paymentTerm) => {
        formGroup.get(SpecFieldNames.PAYMENT_TERMS).setValue(paymentTerm.paymentTermCode);
      }),
      // return a list of options of one item to show applicable payment term for a jobsite
      map((paymentTerm) => {
        const name = _safe(() => paymentTerm.paymentTermType.paymentTermTypeDesc, paymentTerm.paymentTermDesc);
        return [
          {
            id: paymentTerm.paymentTermCode,
            name,
          },
        ];
      }),
    );
  }
}
